import React, { Fragment } from 'react';
// child components
import ArrivalDriverMapComponent from '../arrival-driver-map/arrival-driver-map';
import ArrivalDriverInfoComponent from '../arrival-driver-info/arrival-driver-info';
// import DriverInfoComponent from '../../components/driver-info/driver-info.component';
// import HighlightInfoCollectionComponent from '../../components/highlight-info-collection/highlight-info-collection.component';
// product service
import BookingProductService from '../../services/booking-product.service';
// models
import IDriverTrackingStatus from '../../models/driver-tracking-status.interface';
import ILocation from '../../models/location.interface';
import ITimeslot from '../../models/timeslot.interface';
// styles
const styles = require('./arrival-in-progress-delivery.scss');

declare var exponea: any;
interface IState {
    driverData: IDriverTrackingStatus;
    locationData: ILocation;
    timeslotData: ITimeslot;
    locationType: string;
    loaded: boolean;
}

interface IProps {
    trackingData: any;
    queryParams: any;
    language: string;
    multiLang: any;
}

class ArrivalDriverStatusComponent extends React.Component<IProps, IState> {

    // private product = null;
    public bookingProductService = null;

    constructor(props: any) {
        super(props);
        this.state = {
            driverData: props.trackingData.driverTrackingStatus,
            timeslotData: props.trackingData.collectionSlot !== null ? props.trackingData.collectionSlot : props.trackingData.deliverySlot,
            locationData: props.trackingData.collectionLocation !== null ? props.trackingData.collectionLocation : props.trackingData.deliveryLocation,
            locationType: props.trackingData.collectionLocation !== null ? 'collection' : 'delivery',
            loaded: false
        };
    }

    componentDidMount() {
        this.bookingProductService = new BookingProductService(this.props.trackingData.trackingBookingDetails, this.props.trackingData.collectionSlot);
        // this.product = this.bookingProductService.returnProductDetails();
        this.setState({ loaded: true });
        exponea.track('tracking_screen', { 'page_name': 'DriverTrack', 'product_type': 'ccd'});
    }

    componentWillReceiveProps(props: IProps) {
        if (props.trackingData !== null && props.trackingData.driverTrackingStatus) {
            this.setState({ driverData: props.trackingData.driverTrackingStatus });
            this.setState({ locationData: props.trackingData.collectionLocation !== null ? props.trackingData.collectionLocation : props.trackingData.deliveryLocation });
        }
    }

    public render() {
        // console.log(this.state)
        // const { driverData, locationData } = this.state;
        const { driverData, locationData, timeslotData, locationType } = this.state;
        const { queryParams, language, multiLang, trackingData } = this.props;
        const { driverTrackingStatus } = trackingData;
        const title = multiLang[driverTrackingStatus.titleDisplay + language] || driverTrackingStatus.titleDisplay;
        return (
            <Fragment>
                <div className={styles.mainContent}>
                    <div className={styles.sectionWrapper}>
                        <div className={styles.section}>
                            <div className={styles.card}>
                                <div className={styles.cardBody}>
                                    <h1 className={styles.heading}>{title}</h1>
                                    <div className={styles.sectionWrapperMap}>
                                        <ArrivalDriverMapComponent
                                            language={language}
                                            multiLang={multiLang}
                                            driverData={driverData}
                                            locationData={locationData}
                                            locationType={locationType}>
                                        </ArrivalDriverMapComponent>
                                    </div>

                                    <div>
                                        <ArrivalDriverInfoComponent
                                            language={language}
                                            multiLang={multiLang}
                                            driverData={driverData}
                                            locationData={locationData}
                                            timeslotData={timeslotData}
                                            locationType={locationType}
                                            queryParams={queryParams}
                                            trackingData={this.props.trackingData}
                                        >
                                        </ArrivalDriverInfoComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

}

export default ArrivalDriverStatusComponent;



// WEBPACK FOOTER //
// ./src/components/arrival-in-progress-delivery/arrival-in-progress-delivery.tsx